import { Injectable } from 'angular-ts-decorators';

import { fromEvent, merge, ConnectableObservable, Observable } from 'rxjs';
import { mapTo, startWith, publishReplay } from 'rxjs/operators';

/**
 *
 * Service that expose online/offline events as streams
 */
@Injectable('connectionStatus')
export class ConnectionStatus {
  /**
   * Stream; emits true when browser goes online & emits false when browser
   * goes offline. Start with navigator.onLine & remembers value for later
   * subscription.
   *
   * Note! As the source events, it happens outside of the angular context -
   * the client is responsible to trigger the digest cycle
   */
  public readonly isOnline$: Observable<boolean>;

  constructor($window: ng.IWindowService) {
    'ngInject';

    const offlineStream = fromEvent($window, 'offline'),
      onlineStream = fromEvent($window, 'online');

    // Note can be bring to angular context with tap(() => this.$timeout(() => {}, 0))
    this.isOnline$ = merge(
      onlineStream.pipe(mapTo(true)),
      offlineStream.pipe(mapTo(false)),
    ).pipe(startWith($window.navigator?.onLine), publishReplay(1));

    (<ConnectableObservable<boolean>>this.isOnline$).connect();
  }
}
